import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgParamAzimuth = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M17.25 15.75L21 12L17.25 8.25M21 12H3",
			stroke: "var(--stroke-0, #DFCBF5)",
			strokeOpacity: .7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})
});
export default SvgParamAzimuth;
